module.exports = [
	{
		"name": "Academy Sports & Outdoors",
		"url": "http://www.academy.com",
		"image": "academy.jpg",
		"region": "United States"
	},
	{
		"name": "Amazon",
		"url": "https://www.amazon.com/sentrysafe?&_encoding=UTF8&tag=sentrysafe06-20&linkCode=ur2&linkId=ce82e302771d95040dd9dd5e2748304e&camp=1789&creative=9325",
		"image": "amazon.jpg",
		"region": "United States"
	},
	{
		"name": "Bass Pro Shops",
		"url": "http://www.basspro.com",
		"image": "bass-pro-shops.jpg",
		"region": "United States"
	},
	{
		"name": "BJ's Wholesale Club",
		"url": "http://www.bjs.com",
		"image": "bjs.jpg",
		"region": "United States"
	},
	{
		"name": "Cabela's",
		"url": "https://www.cabelas.com",
		"image": "cabelas.jpg",
		"region": "United States"
	},
	{
		"name": "Costco",
		"url": "https://www.costco.com",
		"image": "costco.jpg",
		"region": "United States"
	},
	{
		"name": "Lowes",
		"url": "https://www.lowes.com",
		"image": "lowes.jpg",
		"region": "United States"
	},
	{
		"name": "Office Depot/OfficeMax",
		"url": "https://www.officedepot.com/a/browse/safes/N=5+733967/",
		"image": "officedepot-officemax.jpg",
		"region": "United States"
	},
	{
		"name": "Sam's Club",
		"url": "https://www.samsclub.com",
		"image": "sams-club.jpg",
		"region": "United States"
	},
	{
		"name": "Shoplet",
		"url": "http://www.shoplet.com",
		"image": "shoplet.jpg",
		"region": "United States"
	},
	{
		"name": "Staples",
		"url": "https://www.staples.com",
		"image": "staples.jpg",
		"region": "United States"
	},
	{
		"name": "Target",
		"url": "https://www.target.com",
		"image": "target.jpg",
		"region": "United States"
	},
	{
		"name": "Home Depot",
		"url": "http://www.homedepot.com",
		"image": "home-depot.jpg",
		"region": "United States"
	},
	{
		"name": "Walmart",
		"url": "https://www.walmart.com",
		"image": "walmart.jpg",
		"region": "United States"
	},
	{
		"name": "Zoro",
		"url": "https://www.zoro.com",
		"image": "zoro.jpg",
		"region": "United States"
	},
	{
		"name": "Acklands Grainger",
		"url": "https://www.acklandsgrainger.com/en",
		"image": "acklands-grainger.jpg",
		"region": "Canada"
	},
	{
		"name": "Basics",
		"url": "https://www.basics.com",
		"image": "basics.jpg",
		"region": "Canada"
	},
	{
		"name": "Costco",
		"url": "https://www.costco.ca",
		"image": "costco.jpg",
		"region": "Canada"
	},
	{
		"name": "Home Hardware",
		"url": "https://www.homehardware.ca/en/brands/sentry",
		"image": "home-hardware.jpg",
		"region": "Canada"
	},
	{
		"name": "Novexco",
		"url": "http://www.novexcodistribution.com",
		"image": "novexco.jpg",
		"region": "Canada"
	},
	{
		"name": "OfficeMax Grand & Toy",
		"url": "https://www.grandandtoy.com",
		"image": "officemax-grand-and-toy.jpg",
		"region": "Canada"
	},
	{
		"name": "Source Office Furnishings",
		"url": "https://www.source.ca",
		"image": "source-office-furnishings.jpg",
		"region": "Canada"
	},
	{
		"name": "Staples",
		"url": "https://www.staples.ca",
		"image": "staples.jpg",
		"region": "Canada"
	},
	{
		"name": "Home Depot",
		"url": "https://www.homedepot.ca/en/home.html",
		"image": "home-depot.jpg",
		"region": "Canada"
	},
	{
		"name": "Walmart",
		"url": "https://www.walmart.ca/en",
		"image": "walmart.jpg",
		"region": "Canada"
	},
	{
		"name": "Ace Hardware",
		"url": "https://www.aceuae.com/en-AE/our-brands/sentry/",
		"image": "ace-hardware.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Asters",
		"url": "https://www.astersonline.com",
		"image": "asters.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Costco",
		"url": "http://www.costco.co.uk",
		"image": "costco-uk.png",
		"region": "United Kingdom"
	},
	{
		"name": "De Raat",
		"url": "http://www.deraat.eu",
		"image": "de-raat.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Ferrimax",
		"url": "https://www.ferrimax.com",
		"image": "ferrimax.png",
		"region": "United Kingdom"
	},
	{
		"name": "NCR Angola",
		"url": "https://www.ncrangola.com",
		"image": "ncr-angola.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Screwfix",
		"url": "http://www.screwfix.com",
		"image": "screwfix.jpg",
		"region": "United Kingdom"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/whereToBuy/retailerData.json
// module id = 695
// module chunks = 0